import { ID, IDPrefixes } from '@griply/types';
import { createPrefixId } from '@griply/utils';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type DeleteTagOptions<TDocRef = unknown, TDb = FirestoreInstance> = {
  tagId: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
  onWriteError: (error: unknown) => void;
};

export const deleteTag = async <TDocRef, TDb = FirestoreInstance>(
  options: DeleteTagOptions<TDocRef, TDb>,
): Promise<void> => {
  const { tagId, doc, deleteDoc, db, onWriteError } = options;

  const tagRef = doc(db, FirestoreCollections.Tags, tagId);
  const relationshipRef = doc(
    db,
    FirestoreCollections.Relationships,
    createPrefixId(tagId, IDPrefixes.Tag),
  );

  detachWrite(deleteDoc(tagRef), onWriteError);
  detachWrite(deleteDoc(relationshipRef), onWriteError);
};
